var lib_core      = require("lib-core");
var THREE         = require("three");

var PositionHandleModel  = require("./../abstract/positionHandleModel.js");

var YHandleModel = function (editorModel, handleId, config) {
    PositionHandleModel.call(this, editorModel, handleId);
};

lib_core.inherit(YHandleModel, PositionHandleModel);
YHandleModel.$class = "YHandleModel";
module.exports = YHandleModel;

YHandleModel.prototype.getSubjectsRotation = function(){
    return this.getSubject().getRotation();
} 

YHandleModel.prototype.released = function(){
    this.selected(false);
}

YHandleModel.prototype.setContactPosition = function(position){
    this.startPosition = position;
    this.selected(true);

    var subject = this.getSubject();
    var basePos = subject.getPosition();
    this.contactOffset = this.startPosition.sub(basePos);
}

YHandleModel.prototype.createMovementPlane = function(ray, point){
    var newRay = new THREE.Vector3(ray.direction.x, 0, ray.direction.z);
    newRay.normalize();

    var zero = new THREE.Vector3();
    var subject = this.getSubject();
    var vecToOrigin = subject.getPosition().toThreejs();

    var distanceToOrigin = zero.distanceTo(vecToOrigin);
    vecToOrigin.normalize();
    var dotProduct = vecToOrigin.dot(newRay);
    var angle = Math.acos(dotProduct);
    var adjLength = distanceToOrigin * Math.cos(angle);
    this.movementPlane.setComponents(newRay.x, newRay.y, newRay.z, -adjLength);
}

YHandleModel.prototype.setMousePosition = function(position){

    var subject = this.getSubject();
    var basePos = subject.getPosition();

    subject.setY(position.sub(this.contactOffset).y);
}



